module.exports = __webpack_public_path__ + "img/p05@3x.5f8143a0.png";